import { ChevronDown, ChevronUp } from "@/shared/foundation/icons";

import styles from "./FloatingScrollButton.module.css";
import type { ScrollTargetPosition } from "./useScrollTargetPosition";

interface ScrollToMessageButtonProps {
  /** Where the target message sits relative to the visible part of the
   *  conversation; the arrow points that way. */
  direction: Exclude<ScrollTargetPosition, "visible">;

  /** Scrolls the conversation until the target message is in view. */
  onClick: () => void;
}

/**
 * Floats beside "Scroll to bottom" and brings the admin explorer's scroll
 * target (e.g. the message a piece of feedback rates) back into view.
 */
export function ScrollToMessageButton({
  direction,
  onClick,
}: ScrollToMessageButtonProps) {
  const Icon = direction === "above" ? ChevronUp : ChevronDown;
  return (
    <button type="button" onClick={onClick} className={styles.button}>
      <Icon className={styles.icon} aria-hidden />
      Scroll to message
    </button>
  );
}
